import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { showErrors, showNotification } from '@/utils/snack'
import ProducerForm from '@/modules/Producer/components/ProducerForm.vue'
import { deleteProducer } from '@/modules/Producer/gql/producer.gql'

@Component({
  components: {
    AppDialog,
    ProducerForm
  }
})
export default class ProducerDialog extends Vue {
  targetProducer: Producer | null = null
  producerDialog = {
    actionType: 'new',
    show: false,
    title: 'New Source',
    disable: false
  }
  deleteProducerDialog = {
    show: false,
    title: 'Delete Source',
    text: ''
  }
  disableConfirm = false

  showProducerEditDialog (e: Event, targetProducer?: Producer) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Source'
    if (targetProducer) {
      this.targetProducer = targetProducer
      actionType = 'edit'
      title = 'Edit Source'
    }
    this.producerDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideProducerEditDialog () {
    this.targetProducer = null
    this.producerDialog = {
      actionType: 'new',
      show: false,
      title: 'New Source',
      disable: false
    }
  }

  async deleteProducer (e: Event, targetProducer: Producer) {
    e.preventDefault()
    e.stopPropagation()
    this.targetProducer = targetProducer
    this.deleteProducerDialog.show = true
  }

  async deleteProducerPost () {
    if (!this.targetProducer) {
      return
    }
    const { id } = this.targetProducer
    this.deleteProducerDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteProducer,
        variables: {
          producerId: Number(id)
        }
      })

      const res = result.data.deleteProducer
      if (res) {
        showNotification({
          msg: 'Delete source successfully',
          type: SnackType.Success
        })
        this.targetProducer = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
